import React, { useState, useEffect } from 'react';
import '../App.css';
import Flippy, { FrontSide, BackSide } from 'react-flippy';

function CardFlip({ imageURI, title, authors, abstract, doi }) {
    const [imageError, setImageError] = useState(false);
    const [imageLoading, setImageLoading] = useState(true);
    const [proxiedUrl, setProxiedUrl] = useState('');

    // Use proxy for external images to bypass CORS
    useEffect(() => {
        if (!imageURI) {
            setProxiedUrl('');
            return;
        }
        
        // If it's an external URL, use our proxy
        if (imageURI.startsWith('http://') || imageURI.startsWith('https://')) {
            const proxyUrl = `http://127.0.0.1:5000/api/proxy-image?url=${encodeURIComponent(imageURI)}`;
            console.log(`Proxying image: ${imageURI} -> ${proxyUrl}`);
            setProxiedUrl(proxyUrl);
        } else {
            setProxiedUrl(imageURI);
        }
    }, [imageURI]);

    const handleImageLoad = () => {
        setImageLoading(false);
        setImageError(false);
    };

    const handleImageError = (e) => {
        console.warn(`Image failed to load, showing placeholder`);
        setImageLoading(false);
        setImageError(true);
    };

    return (
        <div className="cardflip-container">
            <Flippy
                flipOnHover={false}
                flipOnClick={true}
                flipDirection="horizontal"
                className="flippy-box"
                style={{ justifyContent: 'center' }}
            >
                <FrontSide
                    style={{
                        backgroundColor: '#2a2928',
                        boxShadow: `0 4px 8px rgba(0, 0, 0, 0.3)`,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '10px',
                        overflow: 'hidden',
                        position: 'relative'
                    }}
                >
                    {imageLoading && !imageError && (
                        <div style={{
                            position: 'absolute',
                            height: '350px', 
                            width: '100%', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            color: 'white',
                            fontSize: '14px',
                            zIndex: 1
                        }}>
                            Loading image...
                        </div>
                    )}
                    {imageError ? (
                        <div style={{
                            height: '350px', 
                            width: '90%', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            flexDirection: 'column',
                            color: '#e8e8e8',
                            backgroundColor: '#1f1e1d',
                            borderRadius: '8px',
                            padding: '20px',
                            textAlign: 'center',
                            border: '1px solid #8b7aa8'
                        }}>
                            <div style={{fontSize: '64px', marginBottom: '15px'}}>📄</div>
                            <div style={{fontSize: '14px', fontWeight: 'bold'}}>Journal Publication</div>
                            <div style={{fontSize: '11px', marginTop: '5px', opacity: 0.8}}>Image unavailable</div>
                        </div>
                    ) : (
                        proxiedUrl && (
                            <img
                                style={{
                                    maxHeight: '350px', 
                                    maxWidth: '90%', 
                                    objectFit: 'contain',
                                    marginBottom: '10px',
                                    display: imageLoading ? 'none' : 'block'
                                }}
                                src={proxiedUrl}
                                alt={title || "Publication cover"}
                                onLoad={handleImageLoad}
                                onError={handleImageError}
                            />
                        )
                    )}
                    <div style={{alignSelf: 'center', textAlign: 'center', width: '100%'}}>
                        <h2 className="flippy-box-text">{title}</h2>
                    </div>
                </FrontSide>
                <BackSide 
                    style={{
                        backgroundColor: '#2a2928', 
                        boxShadow: `0 4px 8px rgba(0, 0, 0, 0.3)`,
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '15px',
                        overflow: 'hidden'
                    }}
                >
                    <h3 className="flippy-box-text-backside">{title}</h3>
                    <h6 style={{margin: '5px 0', color: '#a896c4', fontWeight: '500'}}>{authors}</h6>
                    <div style={{
                        textAlign: 'justify', 
                        flex: 1,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <p className="flippy-box-text-backside-abstract">{abstract}</p>
                    </div>
                    <a 
                        href={doi} 
                        style={{
                            alignSelf: 'center',
                            marginTop: '10px',
                            padding: '10px 20px',
                            backgroundColor: '#8b7aa8',
                            color: 'white',
                            textDecoration: 'none',
                            borderRadius: '8px',
                            fontWeight: '600',
                            transition: 'background-color 0.2s'
                        }} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#a896c4'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#8b7aa8'}
                    >
                        View Publication
                    </a>
                </BackSide> 
            </Flippy>
        </div>
    )
}

export default CardFlip;